import { StaticImage } from "gatsby-plugin-image"

import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

const Testimonials = () => (
  <div
    sx={{
      mt: 5,
      py: 5,
      px: 4,
      textAlign: "center",
      border: "1px",
      borderColor: "grey",
      borderRadius: "8px",
      fontSize: 1,
    }}
    data-component-name="web-portal-plan-selection-testimonials"
  >
    <div>
      <Heading
        as="h3"
        size="xsm"
        sx={{ mb: 2, fontWeight: "bold", lineHeight: "body" }}
      >
        Echte Menschen – Echte Erfolge
      </Heading>
      Nach nur 6–8 Behandlungswochen feiern unsere Patient:innen erste sichtbare
      Erfolge.
    </div>
    <div>
      <StaticImage
        src="../../../../images/plan-selection/testimonials.png"
        alt=""
        objectFit="contain"
        sx={{ mt: 4, borderRadius: "8px", maxWidth: 620 }}
      />
      <div
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          "& > *": { flex: 1 },
        }}
      >
        <div sx={{ textAlign: "center" }}>Voher</div>
        <div sx={{ textAlign: "center" }}>Nach 2 Monaten</div>
      </div>
    </div>
    <div>
      <div sx={{ mt: 4 }}>
        <span sx={{ fontWeight: "bold" }}>Lotta,</span> Akne-Patientin bei
        FORMEL SKIN
      </div>
      <div sx={{ mt: 1, color: "textDark" }}>
        Eine von 5.000+ tollen Bewertungen
      </div>
    </div>
  </div>
)

export default Testimonials
